export const createPortalRoot = id => {
  const node = document.createElement('div')

  node?.setAttribute('id', id)
  document.body.appendChild(node)

  return node
}

export const getPortalRoot = id => document.getElementById(id)

export const getRoot = id => {
  const node = getPortalRoot(id)

  return Boolean(node) ? node : createPortalRoot(id)
}
